import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PillarModule } from '../pillar/pillar.module'
import { reducers } from './store/reducers/';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';
import { ModuleConfiguration } from './customer.module.config';
import { UserTileComponent } from './components/user-tile.component';
import { UserService } from './services/UserService';
import { UserServiceEffects } from './services/UserService.effects';
import { AddUserDialogComponent } from './components/add-user-dialog.component';
import { UserWorkspaceComponent } from './components/user-workspace.component';
import { customerRoutes } from './routes.config';
import { GroupTileComponent } from './components/group-tile.component';
import { GroupWorkspaceComponent } from './components/group-workspace.component';
import { AddGroupDialogComponent } from './components/add-group-dialog.component';
import { GroupService } from './services/GroupService';
import { GroupServiceEffects } from './services/GroupService.effects';
import { CoreModule } from '../core/core.module';
import { ShortNamePipe } from '../common/pipes/short-name.pipe';
import { ManageRolesComponent } from './components/manage-roles.component';

@NgModule({
  entryComponents: [UserTileComponent, AddUserDialogComponent, GroupTileComponent, AddGroupDialogComponent],
  declarations: [UserTileComponent, AddUserDialogComponent, UserWorkspaceComponent, GroupTileComponent, GroupWorkspaceComponent, AddGroupDialogComponent, ShortNamePipe, ManageRolesComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([UserServiceEffects, GroupServiceEffects]),
    RouterModule.forChild(customerRoutes),
    ReactiveFormsModule,
    PillarModule,
    CoreModule
  ],
  exports: [],
  providers: [UserService, GroupService]
})
export class CustomerModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry) {
    dashboardTilesRegistry.registerTile('administration',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 1,
        tileComponent: UserTileComponent,
        permission: "CustomerModule.Users:View",
        displayName: "Users"
      });
    dashboardTilesRegistry.registerTile('administration',
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 1,
        tileComponent: GroupTileComponent,
        permission: "CustomerModule.Groups:View",
        displayName: "Groups"
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.module.ts